import { SVGProps } from "react"

const LocatorBackArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.3996 7.19922L9.59961 11.9992L14.3996 16.7992"
      stroke={(props.stroke as string) || "black"}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default LocatorBackArrow
